<template>
  <NuxtLayout name="default">
    <div class="error-page flex items-center justify-center p-4">
      <div class="error-content max-w-[500px] mx-auto flex flex-col items-center justify-center gap-[40px] ">
        <div class="error-image">
          <img src="~/assets/img/404.svg" alt="Error" />
        </div>
        <div class="error-message">
          <h1 class="text-[40px] font-bold mb-2 text-darkGrey text-center leading-[48px]">Oops!</h1>
          <div class="text-[24px] font-medium text-darkGrey leading-[32px] text-center">
            Looks like this page doesn’t exist in Fieldman.
          </div>
        </div>
      </div>
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
import { useFMStore } from '@/store/FMStore';

interface ErrorProps {
  error: {
    statusCode: number;
    message?: string;
  };
}

const props = defineProps<ErrorProps>();

const FMStore = useFMStore();
FMStore.loading = false;

useSeoMeta({
  title: props.error.statusCode === 404
    ? 'Page Not Found - 404'
    : `Error ${props.error.statusCode}`,
  description: props.error.statusCode === 404
    ? 'The page you are looking for does not exist or has been moved'
    : 'An error occurred on the server',
});

const handleError = () => {
  clearError({ redirect: '/' });
};
</script>

